import React, { useContext } from 'react';
import { defaultEmbedOptions, IEmbedOptions } from 'src/embed';

export const EmbedContext = React.createContext<IEmbedOptions>(defaultEmbedOptions);
export const EmbedProvider = EmbedContext.Provider;
export const EmbedConsumer = EmbedContext.Consumer;

export const useEmbedOptions = () => useContext(EmbedContext);